//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QlikCollapsableFilterOption from './QlikCollapsableFilterOption'
import PlusMinusIcon from '~sdp-components/Icons/PlusMinusIcon'
import ClearIcon from '~sdp-components/Icons/ClearIcon'

export default {
  components: {
    QlikCollapsableFilterOption,
    PlusMinusIcon,
    ClearIcon
  },
  props: {
    field: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    hideExcluded: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Set to true if we want to show all values regardless of excluded status
     * in full color font
     */
    preventExclusionStyle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      sessionObject: null,
      values: []
    }
  },
  computed: {
    hasSelections() {
      return this.values.filter(val => val.isSelected).length > 0
    }
  },

  async mounted() {
    try {
      // this is in case we do a page refresh
      if (this.sessionObject) {
        await this.removeQlikListeners()
        this.values = []
      }

      // create a session object that will respond to user selections, will use the update methods to get changes
      this.sessionObject = await this.$qlik.generateListObject(this.field, {
        numeric: 1,
        ascii: 1
      })
      this.sessionObject.on('changed', this.update)
      this.values = await this.$qlik.getValuesFromListObject(this.sessionObject)
    } catch (err) {
      console.log('error in QlikCollapsableFilterContainer: initialize', err)
    }
  },

  destroyed() {
    this.removeQlikListeners()
  },
  methods: {
    clearSelections() {
      try {
        this.$qlik.clearField(this.field)
      } catch (error) {
        console.log(
          'error in QlikCollapsableFilter: clearSelections',
          error,
          this.field
        )
      }
    },

    async handleOptionChange({ text, number }) {
      try {
        // this is a toggle, so remove a clicked value if it is already selected
        // but don't affect the state, let update do that, checking the actual qlik field selections
        const selectedValues = this.values.filter(val =>
          val.isSelected ? val.isSelected : false
        )
        const index = selectedValues.map(val => val.text).indexOf(text)
        if (index >= 0) {
          selectedValues.splice(index, 1)
        } else {
          selectedValues.push({ text, number })
        }
        await this.$qlik.selectFieldValues(this.field, selectedValues)
        // this.$emit("selectionsUpdated", { field: this.field, selections: this.values.filter(value => value.isSelected) })
      } catch (error) {
        console.log('error in QlikCollapsableFilter: handleOptionChange', error)
      }
    },

    async removeQlikListeners() {
      if (this.sessionObject) {
        await this.sessionObject.removeListener('changed', this.update)
        return await this.$qlik.destroySessionObject(this.sessionObject)
      } else {
        return false
      }
    },

    async update() {
      this.values = await this.$qlik.getValuesFromListObject(this.sessionObject)
      const selections = this.values.filter(value => value.isSelected)
      // if there are new selections open menu
      if (selections.length) {
        this.isVisible = true
      }
      this.$emit('change', { field: this.field, selections })
    }
  }
}
